import actions from './actions-employee.js'
import mutations from './mutations-employee.js'
import getters from './getters-employee.js'
import state from './state-employee.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}